import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import {  ActivityIndicator, ScrollView } from "react-native";
import {Minus,Plus,ClockCounterClockwise,FunnelSimple, WarningCircle} from '@sharedComponents/Icons/Icons';
import { useEffect, useState } from "react";
import axios from "axios";
import { endpoints } from "@app/api/apis";
import { useAppDispatch, useAppSelector } from "@app/store/hooks";
import PleadegedAssetInfo from "./PleadegedAssetInfo";
import ROUTE from "@app/navigationApp/routes";
import { addCommasToNumber, useDarkMode } from "@app/utils";
import { updateAssetData, updateLinkedApplication } from "@app/store/slices/authSlice";
import AsyncStorage from "@react-native-async-storage/async-storage";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import FilterComponent from "../RemovePledge/FilterComponent";
import Button from "@app/sharedComponents/Button/Button";
import { Warning,Info } from '@app/sharedComponents/Icons/Icons';
import { useDispatch } from 'react-redux';
import { showErrorSheet } from '@app/store/slices/errorSlice';
import handleApiErr from "@app/helper/handleApiErr";
import { LENDER_ID } from "@app/types/regix";
import EmailIcon from "../../../assets/Icons/Email";
import EmailSentSuccess from "../Transactions/components/EmailSentSuccess";
import BackButton from "@app/sharedComponents/BackButton/BackButton";
import PledgedMFShimmer from "./pleadgeMfShimmer";
import fetchUserDetails from "@app/helper/fetchUserInfo";




const PleadgeMF = ({navigation,route}) =>{
    const isDarkMode = useDarkMode();
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const isLoanExpired = useAppSelector((state)=>state.commonReducer.isLoanExpired)
    const [assetList,setAssetList] = useState([]);
    const [isIncreaseLimitNotAllowed,setIsIncreaseLimitNotAllowed] = useState(false)
    const [isUnpledgeRequestInProgress,setIsUnpledgeRequestInProgress] = useState(false)
    const [isSendingEmail,setIsSendingEmail] = useState(false)
    const [revocationRequestDetailsList,setRevocationRequestList] = useState([])
    const [isDecreaseLimitAllowed,setIsDecreaseLimitAllowed] = useState(false)
    const [isUnpledgeNotAllowed,setIsUnpledgeNotAllowed] = useState(false)
    const [filtersSections, setFiltersSections] = useState([]);
    const [manageLimitConfig,setManageLimitConfig] = useState({})
    const [activeFilter, setActiveFilter] = useState('');
    const [isAssetListLoading, setIsAssetListLoading] = useState(true);
    const [checkedFilters, setCheckedFilters] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [isProblemAtLenderEnd, setisProblemAtLenderEnd] = useState(false)
    const [isLoading,setIsLoading] = useState(false)
    const [pledgeMoreLoader,setPledgeMoreLoader] = useState(false);
    const [filteredAssetList, setFilteredAssetList] = useState([]);
    const [isListLoading,setIsListLoading] = useState(false)
    const [showFilter,setShowFilter] = useState(false)
    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
    const [bottomSheetType, setBottomSheetType] = useState(null);
    const [isShimmerLoading,setIsShimmerLoading] = useState(true);
    const eligibleFilters = [];
      const {isfromTDL} = useAppSelector(state => state.platformParams);

    const firebaseParams = useAppSelector((state) => state.firebaseParams);



    const onFilterCheckBoxPressed = (filter) => {{
        const index = checkedFilters.indexOf(filter);
        if (index > -1) {
            checkedFilters.splice(index, 1);
        } else {
            checkedFilters.push(filter);
        }
        setCheckedFilters([...checkedFilters]);
    }}

    const onEditAmountPressed = (asset) => {{
        console.log('asset',asset)
    }}

    const onApplyFilterPressed = () => {{
        if(checkedFilters.length !== 0){
            const filteredAssets = assetList.filter(
                asset => checkedFilters.some(checked => checked.isinCode === asset.isinCode)
              );
        
              console.log("FILTERED LIST",filteredAssets)

              setFilteredAssetList(filteredAssets)
              
              
              
            }     
            else {
                setFilteredAssetList(assetList)
            }
            setShowFilter(false)   
    }}

    

    

    const dispatch = useAppDispatch()
    const fetchpleadedList = ()=>{
        const url = endpoints.pleadgeList + userDetails?.linkedCredits[0]?.creditId
        axios.get(url).then((res)=>{
            res?.data.forEach(item => {
              item.unique_locator = item.isinCode + '_' + item.assetFolioNo;
            });
            console.log('pledgedMFList',res.data)
            dispatch(updateAssetData(res.data))
            setAssetList(res?.data)
                    const equityFunds = res?.data?.filter(item => item.assetSubType === "EQUITY");

            setFilteredAssetList(res?.data)
            setFilteredList(equityFunds)
            
            
            segregateFilters(res?.data)
        }).catch((err)=>{
            console.log('pledgedMFList',err)
        }).finally(() => {
            // for showing shimmer placeholder for 0.5 seconds
            setTimeout(() => {
              setIsShimmerLoading(false);
            }, 500);
          });
    }
    useEffect(()=>{
            fetchpleadedList()
            getManageLimitConfig()
            getRevocationList()
    },[])

    const getManageLimitConfig = () => {
        const url = endpoints.manageLimitConfig + userDetails?.linkedCredits[0]?.creditId
        axios.get(url).then((res)=>{
       

           setManageLimitConfig(res?.data)
           setIsListLoading(false)
        //    navigation.navigate("MF_FETCH")


      
        }).catch((err)=>{
          console.log('newApplication',err) 
        }).finally(()=>{
            setIsListLoading(false)
        })
    
    }
    const getRevocationList = () => {
        console.log("GetRevocationList")
        const url = endpoints.getRevocationList + userDetails?.linkedCredits[0]?.creditId
        axios.get(url).then((res)=>{
         
            setRevocationRequestList(res?.data) 
        //    navigation.navigate("MF_FETCH")


      
        }).catch((err)=>{
          console.log('newApplication',err) 
        }).finally(()=>{
            setIsLoading(false)
        })
    
    }

    const fetchTotalOutstanding = () => {
        const url = endpoints.getForeclosureDetails + userDetails?.linkedCredits[0]?.creditId
        const checkFrozenStatusUrl = endpoints.checkFrozenStatus + userDetails?.linkedCredits[0]?.creditId
        axios.get(checkFrozenStatusUrl)
        .then(() => {
            return axios.get(url);
        })
        .then((res) => {
            const lenderName = userDetails?.linkedCredits[0]?.lendingPartnerId;
            const netPayable = lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase() ? res?.data?.netPayable : res?.data?.totalDue;
            const extraOutstandingBufferBajaj = Number(firebaseParams?.extra_outstanding_buffer || "0");
            const extraOutstandingBufferDsp = Number(firebaseParams?.extra_outstanding_buffer_dsp || "0");
            const netCreditLimit = userDetails?.linkedCredits[0]?.totalDrawingPower || 0 ;
            const extraBufferBajaj = (100 + extraOutstandingBufferBajaj)/100;
            const extraBufferDsp = (100 + extraOutstandingBufferDsp)/100;
            const bufferTotalOutstanding = 
                lenderName.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase()
                ? (netPayable * extraBufferBajaj) : lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? (netPayable * extraBufferDsp) : netPayable;
            const showUnpledgeModal = netCreditLimit < bufferTotalOutstanding ? true : false;
            if(showUnpledgeModal){
                dispatch(
                    showErrorSheet({
                      isErrorSheetVisible: true,
                      errorMessage:  lenderName.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase() ? 
                      'A 10% buffer needs to be maintained on dues to account for market fluctuations. Please repay to un-pledge funds.' : 
                      'Please repay dues to un-pledge funds.',
                      closeOnBackdropPress: true,
                      errorType: 200,
                      errorHeading : 'Insufficient un-pledge limit.',
                      btnName: 'Ok, got it!'
                    }),
                  );
            }
            else{
                navigation.navigate(ROUTE.UNPLEDGE_INSTRUCTIONS);
            }
        })
        .catch((err) => {
            if (handleApiErr(err)) {
                dispatch(
                    showErrorSheet({
                      isErrorSheetVisible: true,
                      errorMessage:  err?.data?.message || 'Service temporarily unavailable',
                      closeOnBackdropPress: true,
                      errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
                      errorHeading : err?.data?.header || 'We’re experiencing a temporary issue with our lending partner. Please try again after sometime',
                      btnName: 'Ok, got it!'
                    }),
                  );
            }
        })
        .finally(() => {
            setIsLoading(false);
        });
    }



const fetchNewApplication = ()=>{
  setPledgeMoreLoader(true)
    const payload =    {
      creditApplicationType: "CREDIT_MODIFICATION_AGAINST_SECURITIES",
  }
  
    const url = endpoints.enhanceLimit + userDetails?.linkedCredits[0].creditId + '/v2'
    axios.post(url,payload).then((res)=>{
      const applicationId = res?.data?.applicationId
      dispatch(updateLinkedApplication(res?.data))
       AsyncStorage.setItem("application_id", applicationId)
       AsyncStorage.setItem("is_from_enhance_limit", "true")
       AsyncStorage.setItem("currentStepId", res?.data?.currentStepId)
       AsyncStorage.setItem('newUserData', JSON.stringify(res?.data))
       fetchUserDetails();
       navigation.navigate(ROUTE.MANAGE_LIMIT_LANDING);
  
    }).catch((err)=>{
      console.log('newApplication',err) 
      if(handleApiErr(err)){
        dispatch(
            showErrorSheet({
              isErrorSheetVisible: true,
              errorMessage:  err?.data?.message || 'Something went wrong',
              closeOnBackdropPress: true,
              errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
              errorHeading : err?.data?.header || 'Verification failed!',
              btnName: 'Ok, got it!'
            }),
          );
      }
     
    }).finally(()=>{
      setPledgeMoreLoader(false)
    })
  }
  
    const pleadeMore = ()=>{
        AsyncStorage.removeItem('isElevate')
        if(manageLimitConfig?.increaseLimitAllowed){
        fetchNewApplication()
    }
    else {

        setIsIncreaseLimitNotAllowed(true)     
    }
    }

    const removePledge = ()=>{

        // navigation.navigate(ROUTE.UNPLEDGE_INSTRUCTIONS)
       if(isLoading)
       return 
        if(revocationRequestDetailsList.length !== 0){
            setIsUnpledgeRequestInProgress(true)
        }
        else if(manageLimitConfig?.decreaseLimitAllowed){
            setIsLoading(true)
          fetchTotalOutstanding()
        }
        else {
            setIsUnpledgeNotAllowed(true)
        }
    }
    //


    const segregateFilters = (fundList) => {
        fundList.map((item) => {
            if (
                eligibleFilters.includes(item.assetSubType)
            ) {
                console.log("INSIDE IF",item.assetSubType)
                // Do nothing basically
            } 
            else { 
                console.log("INSIDE ELSE",item.assetSubType) 
                eligibleFilters.push(item.assetSubType);
            }
        });


        setFiltersSections(eligibleFilters);

        console.log("eligibleFilters",eligibleFilters)

        setActiveFilter(eligibleFilters[0]);

        setIsAssetListLoading(false)

                
}


const renderErrorAtLenderEnd =() => {
    return(
        <BottomSheetContainer
        isVisible={isProblemAtLenderEnd}
        close={() =>{                   
            setisProblemAtLenderEnd(false)

        }}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        containerStyle={{ backgroundColor: '#fefefe' }}
    > 
    
    <ThemedView alignContent="center" justifyContent="center" alignItems="center" padding="lg">

    <Info  color="grey" weight ={"fill"} size={48} />

                <ThemedText marginTop="lg" variant="h5s">Service temporarily unavailable</ThemedText>
                <ThemedView marginTop="sm" backgroundColor={'bg-fill-info'} borderRadius="sm" padding="lg" >
                <ThemedText marginTop="sm" variant="b3r">{"We’re experiencing a temporary issue with our lending partner. Please try again after sometime"}</ThemedText>
                 </ThemedView>

                <Button overRideStyle={{marginTop : 24}} type="SOLID" handlePress={()=> {
                   
                  setisProblemAtLenderEnd(false)

                }} label={"Ok, got it!"}/>
                    


        </ThemedView>
    
    </BottomSheetContainer>
    )

}

  const renderEnhanceLimitBlockCard = () => {
    return(
        <BottomSheetContainer
        isVisible={isIncreaseLimitNotAllowed || isUnpledgeNotAllowed}
        close={() =>{ setIsIncreaseLimitNotAllowed(false)
        setIsUnpledgeNotAllowed(false)
        }}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        containerStyle={{ backgroundColor: '#fefefe' }}
    > 
    
    <ThemedView alignContent="center" justifyContent="center" alignItems="center" padding="lg">

    <WarningCircle size={48} weight='fill' color={themeColorSet['icon-error']} />

                <ThemedText marginTop="lg" variant="h5s">Account set up-in progress</ThemedText>
                <ThemedView marginTop="sm" backgroundColor={'bg-fill-info'} borderRadius="sm" padding="lg" >
                <ThemedText marginTop="sm" variant="b3r">{isUnpledgeNotAllowed? "You’ll be able to remove pledge from funds as soon as the account set up is complete. Please try again after sometime" : "You’ll be able to pledge more funds as soon as the account set up is complete. Please try again after sometime"}</ThemedText>
                 </ThemedView>

                <Button overRideStyle={{marginTop : 24}} type="SOLID" handlePress={()=> {
                   
                   setIsIncreaseLimitNotAllowed(false)
                   setIsUnpledgeNotAllowed(false)

                }} label={"Ok, got it!"}/>
                    


        </ThemedView>
    
    </BottomSheetContainer>
    )
  }

  const renderUnpledgeRequestInProgressCard = () => {
    return(
        <BottomSheetContainer
        isVisible={isUnpledgeRequestInProgress}
        close={() => setIsUnpledgeRequestInProgress(false)}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        containerStyle={{ backgroundColor: '#fefefe' }}
    > 
    
    <ThemedView alignContent="center" justifyContent="center" alignItems="center" padding="lg">

    <Info  color="grey" weight ={"fill"} size={48} />

                <ThemedText marginTop="lg" variant="h5s">Unpledge Request in progress</ThemedText>
                <ThemedView marginTop="sm" backgroundColor={'bg-fill-info'} borderRadius="sm" padding="lg" >
                <ThemedText marginTop="sm" variant="b3r" textAlign="center">{"We’re processing your previous request to unpledge funds. You cannot place a new request until then."}</ThemedText>
                 </ThemedView>
                <Button overRideStyle={{marginTop : 24}} type="OUTLINED" handlePress={()=> {
                   setIsUnpledgeRequestInProgress(false)
                   navigation.navigate(ROUTE.PLEDGE_HISTORY)
                }} label={"View existing request"}/>
                <Button overRideStyle={{marginTop : 24}} type="SOLID" handlePress={()=> {
                   
                   setIsUnpledgeRequestInProgress(false)
                }} label={"Ok, got it!"}/>
                 
                    


        </ThemedView>
    
    </BottomSheetContainer>
    )
  }
  const sendEmail = () => {
    setIsSendingEmail(true)
    const url = endpoints.pdfHoldingStatement + userDetails?.linkedApplications[0]?.accountId;
    axios.get(url).then((res)=>{
      console.log('sendEmail',res?.data);
      setIsBottomSheetVisible(true);
    }).catch((err)=>{
      console.log('sendEmail',err)
      if(handleApiErr(err)){
        dispatch(showErrorSheet({
            isErrorSheetVisible: true,
            errorMessage: err?.data?.message,
            closeOnBackdropPress: true,
            errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
            errorHeading: err?.data?.header || null,
            showErrorHeading: false,
            btnName:'Try again later',
        }))
    }
    }).finally(()=>{
      setIsSendingEmail(false)
    })
  }

    const renderFilter = () =>{
          return(
        <BottomSheetContainer
        isVisible={showFilter}
        close={()=> {
             setShowFilter(false)
        }}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        containerStyle={{ backgroundColor: '#fefefe' }}
        showCloseIcon={true}
    >
        <FilterComponent
          {...{
            filtersSections,
            assetList,
            setFilteredList,
            filteredList ,
            onFilterCheckBoxPressed,
            checkedFilters,
            onEditAmountPressed,
            setCheckedFilters,
            setFilteredAssetList,
            onApplyFilterPressed,
            selectedFilter: activeFilter,
          }}
        />
    </BottomSheetContainer>
        )
    }

      return(
        <>
    <ThemedView
    flexDirection='row'
    justifyContent='space-between'
    bg={'bg-surface-primary'}
    paddingHorizontal='lg'
    borderBottomWidth={1}
    borderBottomColor='border-primary'
    height={60}
    alignItems='center'>
      <ThemedView flexDirection='row' alignItems='center'>
        <BackButton pageName={route?.name} navigation={navigation} />
        <ThemedText color='text-primary' variant='b3m' ml='md'>Pledged mutual funds</ThemedText>
       
      </ThemedView>
      { !isfromTDL &&
        <ThemedPressable 
          hitSlop={15}
          disabled={isSendingEmail}
          onPress={sendEmail}
          flexDirection='row' 
          alignItems='center' 
          backgroundColor='bg-fill-emphasis-primary-1' 
          py='xs' px='sm' borderRadius='xl'>
          <EmailIcon size={12} bgColor={themeColorSet['bg-fill-emphasis-primary-1']} color={isDarkMode ? themeColorSet['white']:null} />
          <ThemedText variant='b5m' textTransform='uppercase' color='text-action-primary' ml='xs' >Email</ThemedText>
          {isSendingEmail && <ActivityIndicator size={12} color={themeColorSet['bg-action-primary']} style={{marginLeft: 4}} />}
        </ThemedPressable>}
    </ThemedView>
      
        <ThemedView backgroundColor={'bg-surface-page'} flex={1}   >
        <ThemedView mx="lg" my="md" px="lg" py="md" backgroundColor="bg-fill-primary" borderRadius="md" >
            <ThemedView flexDirection="row" alignItems="center" justifyContent="space-between">
                <ThemedText variant="b3r" color="text-primary">Portfolio value</ThemedText>
                <ThemedText variant="b1s" color="text-primary">{`₹${addCommasToNumber(userDetails?.linkedCredits[0].totalValueOfAssetsPledged)}`}</ThemedText>
            </ThemedView>
            <ThemedView flexDirection="row" alignItems="center" justifyContent="space-between">
                <ThemedText variant="b3r" color="text-primary">Available credit limit</ThemedText>
                <ThemedText variant="b1s" color="text-emphasis-secondary">{`₹${addCommasToNumber(userDetails?.linkedCredits[0].actualLoanAmount)}`}</ThemedText>
            </ThemedView>
        </ThemedView>
        <ThemedView flexDirection="row" justifyContent="space-between" m="lg">
            <ThemedPressable eventName="PLEDGE_MORE_BUTTON"  onPress={pleadeMore} disabled={pledgeMoreLoader} backgroundColor="bg-fill-primary"flex={1} height={80}  alignItems="center" justifyContent="center">
            {pledgeMoreLoader ? <ActivityIndicator size={"small"}></ActivityIndicator> : <Plus size={24} color={themeColorSet["icon-action-primary"]}/>}
            <ThemedText variant="b4m" color="text-primary" mt="xs">
                    Pledge{'\n'}More
                </ThemedText>
            </ThemedPressable>
            <ThemedPressable eventName="REMOVE_PLEDGE_BUTTON" onPress={removePledge} disabled={isLoading} backgroundColor="bg-fill-primary" flex={1} height={80} mx="sm"  alignItems="center" justifyContent="center">
                
        { isLoading ?                 <ActivityIndicator size={"small"}></ActivityIndicator>
 :  <Minus size={24} color={themeColorSet["icon-action-primary"]}/>}
            <ThemedText variant="b4m" color="text-primary" mt="xs">
                    Remove{'\n'} Pledge
                </ThemedText>
            </ThemedPressable>
            <ThemedPressable backgroundColor="bg-fill-primary" flex={1} height={80}  alignItems="center" justifyContent="center" onPress={()=> {
                navigation.navigate(ROUTE.PLEDGE_HISTORY)
            }}>
            <ClockCounterClockwise size={24} color={themeColorSet["icon-action-primary"]}/>
            <ThemedText variant="b4m" color="text-primary" mt="xs">
                    Pledge{'\n'}History
                </ThemedText>
            </ThemedPressable>
        </ThemedView>
        <ScrollView style={{backgroundColor : themeColorSet['bg-surface-primary'],flex:1}}   >

        <ThemedView p="lg" pb="2xl" backgroundColor="bg-surface-primary" borderTopWidth={1} borderColor="border-primary">
            <ThemedText variant="b3s" color="text-primary" mb="lg">Pledged mutual funds</ThemedText>
            <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center" mb="lg">
                <ThemedText variant="b3r" color="text-primary">{`${filteredAssetList.length} MFs`  }</ThemedText>
                <ThemedPressable flexDirection="row" alignItems="center" onPress={()=> {
                    setShowFilter(true)
                }}>
                    <ThemedText variant="b3r" color="text-primary" mr="xs">Filter</ThemedText>
                    <FunnelSimple size={16} color={themeColorSet["icon-primary"]} />
                </ThemedPressable>
            </ThemedView>
            <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                <ThemedText variant="b4r" color="text-secondary">Mutual fund</ThemedText>
                <ThemedText variant="b4r" color="text-secondary">Credit limit</ThemedText>
            </ThemedView>
            <ThemedView height={1} backgroundColor="border-primary" width="100%" my="sm" />
            {
              isShimmerLoading ? 
                 <PledgedMFShimmer/>
               :   filteredAssetList.map((assetList,index)=><PleadegedAssetInfo key={index} asset={assetList}  isViewOnly={true}/>)
            }
        </ThemedView>

        {renderFilter()}
         {renderEnhanceLimitBlockCard()}
         {renderUnpledgeRequestInProgressCard()}
         {renderErrorAtLenderEnd()}
         
        </ScrollView>
        </ThemedView>
        <BottomSheetContainer
        isVisible={isBottomSheetVisible}
        close={()=> setIsBottomSheetVisible(false)}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        >
        <EmailSentSuccess isTransactionsEmail={false}  closeBottomSheet={()=>  setIsBottomSheetVisible(false)}/>
      </BottomSheetContainer>
        </>
    )
}

export default PleadgeMF;